import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { openUrl } from '@/utils/external-resources'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type DeleteAccountModalProps = { onAction: () => void } & InheritableModalProps

const DeleteAccountModal = ({ onAction, ...props }: DeleteAccountModalProps) => {
  // Hooks
  // ------------------------------------------------------------------------- /
  const theme = useTheme()

  // Template variables
  // ------------------------------------------------------------------------- /
  const supportNumber = '09 246 75 75'

  // Interaction handlers
  // ------------------------------------------------------------------------- /
  const handleCall = () => {
    openUrl(`tel:${supportNumber}`)
    onAction()
  }

  // Render
  // ------------------------------------------------------------------------- /
  return (
    <Modal {...props}>
      <FlexColumn alignContent='center'>
        <FontAwesomeIcon icon={['fal', 'exclamation-triangle']} fontSize={24} />

        <Margin mt={theme.UI.Spacing.Space5} />

        <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
          {t({
            id: 'profile.account-settings.delete-account',
            comment: 'Delete account',
            message: 'Account verwijderen',
          })}
        </H3>

        <P type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
          {t({
            id: 'profile.delete-account-modal.message',
            comment: 'Delete account message',
            message: 'Neem telefonisch contact op met het ziekenhuis als je je account volledig wil verwijderen.',
          })}
        </P>

        <Button variant='Primary' onClick={handleCall}>
          {t({
            id: 'profile.account-settings.delete-account-cta',
            comment: 'Delete account cta',
            message: 'Bel {supportNumber}',
            values: {
              supportNumber,
            },
          })}
        </Button>
        <Margin mt={theme.UI.Spacing.Space2} />
        <Button variant='Tertiary' onClick={props.onClose}>
          {t({
            id: 'globals.cancel',
            comment: 'Global for cancel',
            message: 'Annuleer',
          })}
        </Button>
      </FlexColumn>
    </Modal>
  )
}

export { DeleteAccountModal }
